import React, { useEffect, useMemo, useState } from "react"
import Label from "components/general/Label";
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import Competitor from 'components/presentation/Competitor';
import Discipline from 'components/presentation/Discipline';
import { RscFromStore } from "helpers/utils";
import { getDisciplineRSC } from "helpers/rsc";

const getConfiguration = ({ breakPoint, isAlphabeticalSort = true }) => {
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    let configuration = {
        columns: [],
        sortBy: [],
        disableSort: false
    };
    configuration.sortBy = [{ id: 'Competitor', desc: false }, { id: 'Discipline', desc: false }];
    configuration.columns = isMobile ? TableColumnsSM({ isAlphabeticalSort }) : TableColumns({ isAlphabeticalSort })
    return configuration;
};


const TechnicalOfficialsTable = ({ data }) => {
    const { breakPoint } = useViewport();
    const [isAlphabeticalSort, setIsAlphabeticalSort] = useState(true);
    const config = useMemo(() => getConfiguration({ breakPoint, isAlphabeticalSort }), [breakPoint, isAlphabeticalSort]);
    useEffect(() => {
        let isAlphabetical = !(data?.some(ath => ath?.disciplines?.some(disc => disc?.descriptionOrder !== 0)));
        setIsAlphabeticalSort(isAlphabetical);
    }, [data]);
    return (

        <MirsTable
            className="table-schedule"
            data={data}
            columns={config.columns}
            keyRow='eventUnit-code'
            initialSortBy={config.sortBy}
            id={`mirs-table-technicalofficials`}
            showPagination={true}
        // pageSizeCustom={10}
        />


    )
}

export default TechnicalOfficialsTable;


function TableColumns({ isAlphabeticalSort = true }) {
    return (
        [
            ColumnCompetitor({}),
            ColumnDiscipline({ isAlphabeticalSort }),
        ]
    )
}

function TableColumnsSM({ isAlphabeticalSort = true }) {
    return (
        [
            ColumnCompetitor({}),
            ColumnDiscipline({ isAlphabeticalSort }),
        ]
    )
}

export function ColumnDiscipline({ disableSort = false,
    className = 'schedule-discipline text-start',
    headerClassName = 'text-start w-30',
    label = "HeaderDiscipline",
    isAlphabeticalSort = true
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            sortType: isAlphabeticalSort ? 'absoluteOrderString' : 'absoluteOrderNumber',
            accessor: (props) => {
                return isAlphabeticalSort ? props?.disciplines?.find(x => x !== undefined)?.description?.toLowerCase() : props?.disciplines?.find(x => x !== undefined)?.descriptionOrder;
            },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Discipline',
            multiSort: [{ id: 'Discipline' }, { id: 'Competitor', desc: false }],
            Cell: (props) => {
                const rsc = RscFromStore();
                const disc = getDisciplineRSC(rsc);
                const disciplines =  props.cell.row.original?.disciplines?.filter(x => x !== undefined)
                return disciplines?.map(discipline =>
                    < Discipline hasLink={true} code={discipline?.code} description={discipline?.description} />
                )
            }
        }
    )
}


export function ColumnCompetitor({
    disableSort = false,
    className = 'schedule-discipline text-start',
    headerClassName = 'text-start',
    label = "LabelName"
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            id: 'Competitor',
            accessor: (props) => props?.name?.toLowerCase(),
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            multiSort: [{ id: 'Competitor' }, { id: 'Discipline', desc: false }],
            Cell: (props) => {
                const row = props.cell.row.original
                return (
                    <Competitor {...row} hideNoc={true} hidePicture={false} key={`participant-${row?.code}`} />
                )
            }
        }
    )
}

